import {
  Component,
  HostListener,
  OnInit,
} from "@angular/core";
import { MarcaService } from "../../../../../shared/services/marca.service";
import { FormBuilder, FormGroup, Validators,AbstractControl, ValidationErrors } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { Utils } from "../../../../../shared/utils/Utils";
declare var require;
const Swal = require("sweetalert2");
@Component({
  selector: 'app-listado',
  templateUrl: './listado.component.html',
  styleUrls: ['./listado.component.scss']
})
export class ListadoComponent implements OnInit {

  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;
  public searchText: string = ''; // Texto de búsqueda  
  marcas: any;
  errores: any = {};
  editMode: boolean;
  formMarca: FormGroup;
  marcaSeleccionada: any;
  filteredTableItems: MarcaService[];
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  
  
  constructor(
    private marcaService: MarcaService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    
  ) { }

  maxDate: string;
  minDate: string;
  estadoDeshabilitado = true;

  ngOnInit() {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    this.minDate = formattedDate;
    this.maxDate = formattedDate;

    //Listado de marcas
    this.listarMarcas();

    // crear form de la marca
    this.formMarca = this.fb.group({
    id: [null],
    marca: ['', [Validators.required, this.noSoloEspacios]],
    estado: [1],
    usuario: ['admin'],

    });

  }


  
  listarMarcas(): void {
    this.marcaService.getMarcas().subscribe({
      next: (data) => {
        this.marcas = data;
         this.filteredTableItems =this.marcas; // ✅ Inicializa la tabla filtrada
      },
      error: (err) => {
        console.error("❌ Error cargando marcas:", err);
      },
    });
  }

  openModalMarca(content: any, id?: number) {
    if (id) {
      this.editMode = true; // 👈 Editar
      this.marcaService.getMarcaByNombre(id).subscribe({
        next: (marcaData) => {
          this.marcaSeleccionada = marcaData;
          this.formMarca.patchValue(marcaData);
          this.modalService.open(content, { size: "md", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrada",
            text: `No se encontró una marca con el nombre ${id}.`,
          });
        },
      });
    } else {
      this.editMode = false; // 👈 Crear
      this.marcaSeleccionada = null;
      this.formMarca.reset();
      this.modalService.open(content, { size: "md", backdrop: "static" });
    }
  }
  
  guardarMarca() {
    if (this.formMarca.invalid) {
      Swal.fire({
        icon: "error",
        title: "Completa el campo de MARCA",
        text: "El campo no puede estar vacio.",
      });
      return;
    }

  const datosMarca = {
    ...this.formMarca.value,
    usuario: "admin" // Puedes hacerlo dinámico si lo tomas de una sesión
  };

    if (this.editMode && this.marcaSeleccionada) {
      // Comparar si hay cambios en los datos
      const datosSinCambios =
        JSON.stringify(this.marcaSeleccionada) ===
        JSON.stringify(datosMarca);

      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones.",
        });
        return;
      }

      this.marcaService
        .updateMarca(
          this.marcaSeleccionada.id,
          datosMarca
        )
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Marca actualizada correctamente.",
            });
            this.cerrarModalYRecargar();
          },
          error: (err) => {
            this.mostrarError(err, "Error al actualizar la Marca");
          },
        });
    } else {
      this.marcaService
        .createMarca(datosMarca)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Guardado exitoso",
              text: "Marca registrada correctamente.",
            });
            this.formMarca.reset();
            this.cerrarModalYRecargar();
          },
          error: (err) => {
            this.mostrarError(err, "Error al guardar la Marca");
          },
        });
    }
  }

  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarMarcas(); // Recarga las tarjetas para la placa actual
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  actualizarEstadoAInactivo(marca: string) {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar la marca: ${marca}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.marcaService.inactivarMarca(marca).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Marca inactivada!",
              text: "El estado de la marca ha sido actualizado correctamente.",
              confirmButtonText: "Aceptar",
            });
  
            // Actualizar estado localmente
  
            // Recargar tabla y cerrar modal si aplica
            this.cerrarModalYRecargar();
  
            console.log("Marcas actualizadas:", this.marcas);
          },
          error: (error) => {
            const mensaje =
              error?.error?.message || "No se pudo actualizar el estado de la marca";
  
            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });
  
            console.error("Error al inactivar marca:", error);
          },
        });
      }
    });
  }

  exportToPDF(tableId:string,nameFile:string,titleFile:string) {
    Utils.exportToPDF(tableId, nameFile,titleFile);
  }
  
  exportarExcel(tableId:string,nameFile:string) {
      Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
  

 
 noSoloEspacios(control: AbstractControl): ValidationErrors | null {
  const valor = control.value || '';
  if (valor.trim().length === 0) {
    return { soloEspacios: true };
  }
  return null;
}

filterData() {
    const search = this.searchText.toLowerCase();
    console.log(search);
    this.filteredTableItems = this.marcas.filter(marca => {
      // Concatenamos los campos visibles en la tabla
      const values = [
        marca.marca,

      ];

      // Convertimos todo a texto y unimos
      const combined = values
        .map(val => (val ? val.toString().toLowerCase() : ''))
        .join(' ');

      return combined.includes(search);
    });

    this.page1 = 1; // Reinicia a la primera página
  }

sortData(column: string): void {
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  this.filteredTableItems.sort((a, b) => {
    const aValue = this.getValue(a, column);
    const bValue = this.getValue(b, column);

    if (aValue == null) return 1;
    if (bValue == null) return -1;

    if (typeof aValue === 'string') {
      return this.sortDirection === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    return 0;
  });
}

getValue(item: any, column: string): any {
  switch (column) {
    case 'marca': return item.marca;
    default: return '';
  }
}

}